module.exports = __webpack_public_path__ + "media/images/home/main/aa/5-b062a4b7abfa4673f0b20ffb224e1d49.png";